import { errorMessages } from "../../constants/errorMessages";

/**
 * Validates the account phone number value.
 * - Ensures a non-empty, 10-digit U.S. phone number.
 * - Returns any sync validation errors; call site can decide next steps.
 */
export const handleAcctValidationErrors = (
  acctPhoneNumberValue,
  setAcctPhoneNumberErrors
) => {
  let errors = {};

  if (acctPhoneNumberValue.length === 0) {
    // empty field
    errors.acctPhoneNumberErrors = errorMessages.phone;
  } else if (acctPhoneNumberValue.length !== 10) {
    // incorrect length
    errors.acctPhoneNumberErrors =
      "Please enter a valid 10-digit phone number.";
  }

  setAcctPhoneNumberErrors(errors.acctPhoneNumberErrors || "");
  return { errors };
};
